<ng-container *ngIf="Selected !== null">
    <div class="ticket">
        <ion-item class="header" color="warning" lines="none">
            <ion-label *ngIf="InvoiceForm">
                {{ tr('@place_receipt_invoice_title') }}
            </ion-label>
            <ion-label *ngIf="!InvoiceForm">
                {{ tr('@place_receipt_title') }}
            </ion-label>
            <ion-icon *ngIf="InvoiceForm" slot="end" name="close-outline" (click)="OnCancelInvoice()"></ion-icon>
            <ion-icon *ngIf="!InvoiceForm" slot="end" name="close-outline" (click)="OnSelectTicket(null)"></ion-icon>
        </ion-item>
        <upp-scrollable class="guest-panel-scroll" [scrollbar]="'none'" [ngClass]="{ 'paper': !InvoiceForm }">
            <ng-container *ngIf="InvoiceForm">
                <upp-client-edit uppDataid="guestreceipt-client-edit"
                    [place]="place"
                    [client]="InvoiceClient"
                    [lookup]="false"
                    (Changed)="OnClientChange($event)">
                </upp-client-edit>
                <ion-item *ngIf="CanOfferSendInvoice"
                    class="send-invoice"
                    lines="none"
                    [class.disabled]="!CanEnableSendInvoice">
                    <ion-label>{{ tr('@place_receipt_send_invoice') }}</ion-label>
                    <ion-checkbox uppDataid="guestreceipt-send-invoice-check"
                        slot="end"
                        [checked]="SendInvoiceEmail"
                        [disabled]="!CanEnableSendInvoice"
                        (ionChange)="OnSendInvoiceEmailChange($event)">
                    </ion-checkbox>
                </ion-item>
                <div class="form-spacer"></div>
            </ng-container>
            <div class="printable-host" [hidden]="InvoiceForm">
                <upp-ticket-print #printable [ticket]="Selected" [display]="!InvoiceForm"></upp-ticket-print>
                <div class="preview-spacer"></div>
            </div>
        </upp-scrollable>

        <div class="form-buttons">
            <ng-container *ngIf="InvoiceForm">
                <ion-button uppDataid="guestreceipt-create-invoice-button"
                    color="warning"
                    size="large"
                    expand="full"
                    [disabled]="!CanCreateInvoice"
                    (click)="OnCreateInvoice()">
                    {{ tr(InvoiceConfirmLabel) }}
                </ion-button>
            </ng-container>
            <ng-container *ngIf="!InvoiceForm">
                <upp-form *ngIf="CanRequestInvoice" class="invoice-cta">
                    <upp-form-warning uppDataid="guestreceipt-request-invoice-button"
                        lines="paper"
                        title="{{ tr('@place_receipt_invoice_title') }}"
                        subtitle="{{ tr('@place_receipt_invoice_message') }}"
                        (click)="OnRequestInvoice()">
                    </upp-form-warning>
                </upp-form>
                <upp-form *ngIf="CanModifyInvoice" class="invoice-cta">
                    <upp-form-warning uppDataid="guestreceipt-modify-invoice-button"
                        lines="paper"
                        title="{{ tr('@place_receipt_modify_invoice_title') }}"
                        subtitle="{{ tr('@place_receipt_modify_invoice_message') }}"
                        (click)="OnModifyInvoice()">
                    </upp-form-warning>
                </upp-form>
                <ion-button uppDataid="guestreceipt-download-button" color="warning" size="large" expand="full" (click)="OnDownloadPDF()">
                    {{ tr('@place_receipt_download') }}
                </ion-button>
            </ng-container>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="Selected === null">
    <div class="ticket">
        <ion-item class="header" color="warning" lines="none">
            <ion-label>
                {{ tr('@place_receipts_list') }}
            </ion-label>
            <ion-icon slot="end" name="close-outline" (click)="OnClose()"></ion-icon>
        </ion-item>
        <upp-scrollable class="guest-panel-scroll" [scrollbar]="'none'">
            <ion-item class="title">
                <ion-label>
                    {{ tr('@place_ticket_receipt_choose') }}
                </ion-label>
            </ion-item>
            <ion-list *ngIf="Tickets.length > 0">
                <upp-guest-ticket-thumb *ngFor="let ticket of Tickets; trackBy: TicketTrack"
                    [ticket]="ticket"
                    (Open)="OnSelectTicket($event)">
                </upp-guest-ticket-thumb>
            </ion-list>
            <p *ngIf="Tickets.length === 0">{{ tr('@place_receipts_empty') }}</p>
            <div class="list-spacer"></div>
        </upp-scrollable>
        <div class="form-buttons">
            <ion-button uppDataid="guestreceipt-close-button" color="warning" size="large" expand="full" (click)="OnClose()">
                {{ tr('@place_receipt_done') }}
            </ion-button>
        </div>
    </div>
</ng-container>
